import React from 'react';
import { useTheme } from 'react-native-paper';
import { times } from 'lodash';

import { Row } from './styled';
import { Props } from './types';

const Component: React.FC<Props> = ({ children, value, color, max = 5 }) => {
  const theme = useTheme();

  if (!React.isValidElement(children)) {
    return null;
  }

  return (
    <Row>
      {times(max - value).map((index) =>
        React.cloneElement(children, {
          key: index,
          style: { color: theme.colors.placeholder },
        })
      )}
      {times(value).map((index) =>
        React.cloneElement(children, {
          key: index,
          style: { color: color ?? theme.colors.primary },
        })
      )}
    </Row>
  );
};

Component.displayName = 'Score';

export default Component;
